import { z } from 'zod';

export const cashierFormSchema = z.object({
  email: z.string().email('Enter a valid email'),
  displayName: z.string().min(1, 'Name is required').max(120),
  role: z.enum(['CASHIER', 'MANAGER']),
  storeId: z.string().min(1, 'Select a store'),
});
export type CashierFormInput = z.infer<typeof cashierFormSchema>;

export const cashierEditSchema = z.object({
  displayName: z.string().min(1, 'Name is required').max(120),
  role: z.enum(['CASHIER', 'MANAGER']),
  storeId: z.string().min(1, 'Select a store'),
});
export type CashierEditInput = z.infer<typeof cashierEditSchema>;

export const offlinePasswordSchema = z.object({
  password: z.string().min(6, 'At least 6 characters').max(128, 'At most 128 characters'),
  confirm: z.string(),
}).refine((d) => d.password === d.confirm, {
  message: 'Passwords do not match',
  path: ['confirm'],
});
export type OfflinePasswordInput = z.infer<typeof offlinePasswordSchema>;
